// extracted by mini-css-extract-plugin
export default {"burger":"Header_burger__R1GJm","active":"Header_active__Ekqe6","desktopOnly":"Header_desktopOnly__cJoPi"};